"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const builders = __importStar(require("./builders"));
const Builder_1 = __importDefault(require("../Builder"));
class Three9Builder extends Builder_1.default {
    constructor() {
        super();
    }
    /**
     *
     * @param data FormattedData[]
     * @returns Object[]
     */
    buildSummary(data) {
        let metric = "";
        data[0].run.type === "Melt" ? (metric = "Peak") : (metric = "Cq");
        let cqLayout = [
            [
                "User Name",
                "Thermocycler",
                "HW Number",
                "HW Mac Address",
                "Run Name",
                "Date",
                "Sample Name",
                "Well Number",
                "Fluorophore",
                metric,
                "End RFU",
                "Threshold",
            ],
        ];
        data.forEach((item) => {
            const { run, user, protocol } = item;
            const { version, name, timestamp } = run;
            run.targets.forEach((target) => {
                let value;
                data[0].run.type === "Melt"
                    ? (value = target.peak)
                    : (value = target.cq);
                cqLayout.push([
                    user.username,
                    version.bleName,
                    version.serialNumber,
                    version.macAddress,
                    name,
                    timestamp,
                    target.sampleName,
                    target.wellNumber + 1,
                    target.color,
                    value,
                    target.endRfu,
                    Math.round(target.threshold * Math.pow(10, 6)) / Math.pow(10, 6),
                ]);
            });
        });
        return cqLayout;
    }
    /**
     *
     * @param data FormattedData[]
     * @returns any[][]
     */
    buildDetailed(data) {
        let sheetNames = {};
        let builtData = data.map((item) => {
            let runType = item.run.type;
            if (!runType) {
                runType = !(item.standardCurve.green.slopes ||
                    item.standardCurve.amber.slopes ||
                    item.standardCurve.red.slopes)
                    ? "Qualitative Run"
                    : "Quantitative Run";
            }
            return {
                header: builders.header(item),
                wellInfo: builders.wellInfo(item),
                results: builders.results(item),
                baselineData: builders.baselineData(item, true),
                rawData: builders.rawData(item, true),
                duration: builders.duration(item),
                protocol: builders.protocol(item),
                fluorophores: builders.fluorophores(item),
                qrData: builders.qrData(item),
                standard: builders.standard(item, runType),
                location: builders.location(item),
                notes: builders.notes(item, true),
                optional: builders.optional(item.optional),
                version: builders.version(item),
                xlsxVersion: builders.xlsxVersion(item, "v1.1.0"),
                sheetName: builders.sheetName(item, sheetNames),
            };
        });
        return builtData;
    }
    /**
     *
     * @param data Object
     * @returns any[][]
     */
    layout(item) {
        const SPACE = [null];
        return [
            ...item.header,
            SPACE,
            ...item.wellInfo,
            SPACE,
            ...item.results,
            SPACE,
            ...item.baselineData,
            SPACE,
            ...item.rawData,
            SPACE,
            ...item.duration,
            SPACE,
            ...item.protocol,
            SPACE,
            ...item.fluorophores,
            SPACE,
            ...item.qrData,
            SPACE,
            ...item.standard,
            SPACE,
            ...item.location,
            SPACE,
            ...item.notes,
            SPACE,
            ...item.optional,
            SPACE,
            ...item.version,
            SPACE,
            ...item.xlsxVersion,
        ];
    }
}
exports.default = Three9Builder;
